import type { Template, TunaPlugin } from '@tunasong/plugin-lib'
import type { EntityType } from '@tunasong/schemas'
import { EntityAvatar, Typography } from '@tunasong/ui-lib'
import type { FC } from 'react'
import styles from './template-card.module.css'

interface CreateEntityCardsProps {
  plugin: TunaPlugin
  title: string
  description: string
  template?: Template
  selected?: boolean
  onSelect: () => void
}

/** Create one or more cards from a plugin */
export const TemplateCard: FC<CreateEntityCardsProps> = props => {
  const { onSelect, title, description, selected, plugin, template } = props

  const { template: templateContent } = template ?? {}

  if (!templateContent) {
    return null
  }

  return (
    <div
      onClick={onSelect}
      className={styles.card}
      style={{
        borderColor: selected ? 'var(--tuna-palette-primary-dark)' : 'var(--tuna-palette-divider)',
        borderWidth: selected ? 2 : 1,
      }}
    >
      <div className={styles.cardHeader}>
        <EntityAvatar type={plugin.node?.type as EntityType} />
        <Typography variant="subtitle1">{title}</Typography>
      </div>
      <Typography variant="body2" color="textSecondary">
        {description}
      </Typography>
    </div>
  )
}

export default TemplateCard
